<template>
  <up-card>
    <div class="photo__wrapper">
      <div class="map-item">
        <span class="country"></span>
        <span class="stand">{{ stand }}</span>
        <button
          @click.stop.prevent="markCompany"
          class="mark-company"
        >
          <i :class="[marked ? 'exu-bookmark-check-fill' : 'exu-bookmark' ]"/>
        </button>
      </div>
      <div class="logo-item">
        <company-logo :src="logo" />
      </div>
      <div class="company-item">
        {{ companyName }}
      </div>
    </div>
    <template v-slot:stretch-link>
      <router-link
        :to="{ name: 'exhibitorProfile', params: { id: `${this.exhibitorId}` } }"
        class="stretch-link"
      />
    </template>
  </up-card>
</template>

<script>
import { CompanyLogo } from '@/components/atoms';

export default {
  name: 'ExhibitorCard',
  components: { CompanyLogo },
  props: {
    logo: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      requared: true,
    },
    stand: {
      type: String,
      default: '',
    },
    country: {
      type: String,
      default: '',
    },
    marked: {
      type: Boolean,
      default: false,
    },
    exhibitorId: {
      type: [String, Number],
      requared: true,
    },
  },
  computed: {
    companyName() {
      const MAX_LENGTH = 28;
      // Если строка короче или равна максимальной длине, возвращаем как есть
      if (this.company.length <= MAX_LENGTH) {
        return this.company;
      }
      // Обрезаем до максимальной длины
      const trimmed = this.company.substring(0, MAX_LENGTH);
      // Находим последний пробел в обрезанной строке
      const lastSpaceIndex = trimmed.lastIndexOf(' ');
      // Если пробел найден, обрезаем до него, иначе обрезаем до MAX_LENGTH
      if (lastSpaceIndex > 0) {
        return `${trimmed.substring(0, lastSpaceIndex)}...`;
      }
      // (зависит от требований)
      // Если пробелов нет, возвращаем пустую строку или обрезанную часть
      return ''; // или return trimmed;
    },

  },
  methods: {
    markCompany() {
      this.$emit('marking', this.exhibitorId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.photo__wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  overflow: hidden;

  // &:after {
  //   content: '';
  //   grid-column: start / end;
  //   grid-row: start / end;
  //   display: block;
  //   padding-bottom: 50%;
  // }
  // .col-6 &:after {
  //   padding-bottom: 100%;
  // }
  .map-item {
    display: flex;
    align-items: start;

    .stand {
      flex: 1 1 100%;
    }
    .mark-company {
      display: flex;
      // width: 32px;
      width: 1em;
      // height: 32px;
      height: 1em;
      justify-content: center;
      align-items: center;
      color: $color-accent;
      font-size: 20px;
      line-height: 20px;
      // border: 2px solid #e62d86;
      border: none;
      // border-radius: 4px;
      background-color: transparent;

      position: relative;
      z-index: 99;

      // &.selected {
      //   color: #ffffff;
      //   background-color: #e62d86;
      // }
    }
  }
  .logo-item {
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: inherit;
    margin: 0 auto;
    overflow: hidden;
    // height: 112px;
    flex: 1 1 100%;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .company-item {
    font-size: 14px;
    font-weight: 700;
  }
}
// .col-6 {
//   img {
//     max-height: 35px;
//   }
// }
// .col-12, .profile-card {
//   img {
//     max-height: 44px;
//   }
// }
.stretch-link {
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
</style>
